import React from 'react'
import styled from 'styled-components'

type StockBannerProps = {
  type?: 'warning' | 'error'
  children: React.ReactNode
}

const StockBanner: React.FC<StockBannerProps> = ({
  type = 'warning',
  children
}) => {
  return <StyledBanner type={type}>{children}</StyledBanner>
}

const StyledBanner = styled.div<{ type: 'warning' | 'error' }>`
  display: flex;
  padding: 16px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid
    ${({ type, theme }) =>
      type === 'error' ? theme.color.status.danger : theme.color.status.warning};
  background: ${({ type, theme }) =>
    type === 'error' ? 'rgba(218, 32, 38, 0.20)' : 'rgba(222, 124, 18, 0.20)'};
  color: ${({ type, theme }) =>
    type === 'error' ? theme.color.status.danger : theme.color.status.warning};
`

export default StockBanner
